import { Injectable } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { environment } from '../../../../environment/environment';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { SharedService } from '../../../shared/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class CaseDetailsService {
  constructor(private apiService: ApiService, private sharedService: SharedService) { }
  orderkey: any;

  secionOrGridShow: any
  tablenameForSection: any;
  selectedSection: any
  gridHeaders: any
  gridAddedlables: any
  selected_value: any
  allDynamicFields: any
  modulename: string = ''
  actionkey: string = ''

  getDynamicFieldData(moduleId: string, roleType: string) {
    return this.apiService.get(`${environment.case_api_url}/api/case/getModuleList?locale=${'en'}&moduleId=${moduleId}&role=${roleType}`)
  }
  addDynamicFieldMaster(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/DynamicFieldMaster/createOrUpdate`, payload)
  }
  updateDynamicFieldMaster(id: any, active: any) {
    return this.apiService.get(`${environment.case_api_url}/api/DynamicFieldMaster/updateStatus?id=${id}&status=${active}&locale=en`)
  }

  // For get the dataset for dropdown type field
  getDataset() {
    return this.apiService.get(`${environment.case_api_url}/api/generic/getGenericMasterList?catgId=PICKLIST_DATASET`)
  }

  // For get the table names
  getTableNames() {
    // return this.apiService.get(`${environment.case_api_url}/api/database/tables`)
    return this.apiService.get(`${environment.case_api_url}/api/generic/getGenericMasterList?catgId=TRANSACTION_TABLES`)
  }

  // For get the columns of the table
  getColumns(tableName: any) {
    return this.apiService.get(`${environment.case_api_url}/api/database/columns?tableName=${tableName}`)
  }

  // For update the template
  updateTemplate(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/updateTemplate?locale=${'en'}`, payload)
  }

  getDropdownData(dataset: any) {
    return this.apiService.get(`${environment.case_api_url}/api/generic/getGenericMasterList?catgId=${dataset}`)
  }
  getDropdownDataUsingFieldId(fieldId: any): Observable<any> {
    return this.apiService.get(`${environment.case_api_url}/api/reference-data/lookup/${fieldId}`)
  }

  getDropdownDataFromExternalApi(dataset: any) {
    return this.apiService.get(`${environment.configuration_api_url}/api/configuration-values/code/equal/${dataset}`)
  }
  getDropdownDataForModules() {
    return this.apiService.get(`${environment.configuration_api_url}/api/system-modules/all`)
  }
  getDropdownDataForCountry() {
    return this.apiService.get(`${environment.configuration_api_url}/api/country/all`)
  }
  getDropdownDataForCurrency() {
    return this.apiService.get(`${environment.configuration_api_url}/api/currency/all`)
  }
  // For save the data
  saveCaseManagement(payload: any, sectioncode: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/createOrUpdate?sectionCode=${sectioncode}&locale=en`, payload)
  }
  saveCaseInformation(payload: any, isFinalSave: boolean) {
    return this.apiService.post(
      `${environment.case_api_url}/api/case/createOrUpdate?entityName=CaseInformation&locale=en&isFinalSave=${isFinalSave}`,
      payload,
    )
  }
  // For view the single records in case information
  viewCaseManagement(identifier: any) {
    return this.apiService.get(`${environment.case_api_url}/api/case/getDetails?identifier=${identifier}&type=customer_information&locale=en`)
  }
  // For getting grid data for altered scenario
  getAlteredScenarioList(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/grid/dynamic/LandingList?locale=en`, payload)
    // http://localhost:42020/api/CaseManagement/grid/dynamic/LandingList?locale=en
  }
  getDashboardDetails(): Observable<any> {
    return this.apiService.get('/assets/casemanagement.json');
  }


  getCasedetails(payload: any) {
    return this.apiService.post(`${environment.common_url}/common/dynamic/detail`, payload)
  }

  getLandingList(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/dynamic/LandingList?locale=en`, payload)
  }
  getLandingJSONList(payload: any) {
    return this.apiService.get(`${environment.common_url}/common/landing/count?moduleCode=` + payload)
  }

  getWorkflowLandingList(payload: any) {
    return this.apiService.post(`${environment.workflow_api_url}/api/workflow-definitions/list`, payload)
  }

  getDashboardCounts() {
    return this.apiService.get(`${environment.workflow_api_url}/api/workflow-definitions/status/count`)
  }

  createWorkFlow(payload: any) {
    return this.apiService.post(`${environment.workflow_api_url}/api/workflow-definitions/createWorkflow`, payload)
  }

  // getWorkFlowList()
  // {
  //   http://192.168.10.140:42023/api/CaseManagement/dynamic/LandingList?locale=en
  // }


  getWorkFlowById(id: any) {
    return this.apiService.get(`${environment.workflow_api_url}/api/workflow-definitions/${id}`)
  }

  updateAction(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/update-altered-scenario`, payload)
  }


  updateAssignto(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/update-case-information`, payload)
  }
  getNotifications(payload: any) {
    return this.apiService.post(`${environment.notification_api_url}/api/get/notification/details`, payload)
  }

  getNotificationCount(payload: any) {
    return this.apiService.post(`${environment.notification_api_url}/api/in-app/count`, payload)
  }
  updateAllNotifications(payload: any) {
    return this.apiService.post(`${environment.notification_api_url}/api/in-app/update-status-by-user`, payload)
  }

  updateNotification(payload: any) {
    return this.apiService.post(`${environment.notification_api_url}/api/update/inapp/notification/status`, payload)
  }
  getWorkflowActions(payload: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Tenant-Id': 'DEFAULT_TENANT',
      'X-User-Role': payload?.userRole || this.sharedService.userType || 'maker',
      'X-User-Id': payload?.userId || this.sharedService.userId || ''
    });
    return this.apiService.get(
      `${environment.workflow_api_url}/api/workflow-instance/actions/${payload?.referenceType}/${payload?.referenceId}`,
      { headers }
    );
  }

  chooseWorkflowAction(payload: any) {
    return this.progressWorkflowAction(payload?.referenceType, payload?.referenceId, payload?.action)
  }

  progressWorkflowAction(referenceType: string, referenceId: string, chosenAction: string) {
    return this.apiService.post(
      `${environment.workflow_api_url}/api/workflow-instance/progress/${referenceType}/${referenceId}?chosenAction=${chosenAction}`
    )
  }

  submitApproval(requestId: string, approved: boolean, comments: string) {
    return this.apiService.post(
      `${environment.workflow_api_url}/api/v1/workflow/control/approval/${requestId}?approved=${approved}`,
      { comments }
    )
  }
  registerWorkflowDefinition(payload: any) {
    return this.apiService.post(`${environment.workflow_api_url}/api/workflow-instance/start?referenceType=${payload?.referenceType}&referenceId=${payload?.referenceId}`)
  }

  downloadFile(filename: string) {
    return this.apiService.get(`${environment.case_api_url}/api/generic/download?filename=${filename}`, { responseType: 'blob', observe: 'response' });
  }
  saveRuleBuilder(payload: any) {
    return this.apiService.post(`${environment.rule_api_url}/rule/add/builders-notes?locale=en`, payload)
  }
  getRuleBuilders(ruleId: string) {
    return this.apiService.get(`${environment.rule_api_url}/rule/get-builders-notes/${ruleId}?locale=en`);
  }
  getRuleHistory(ruleId: string) {
    return this.apiService.get(`${environment.rule_api_url}/rule/history/${ruleId}?locale=en`);
  }
  getlandingListConfig(moduleCode: string) {
    return this.apiService.get(`${environment.common_url}/generic/module-config?moduleCode=${moduleCode}`);
  }
  dynamicLandingList(apiUrl: string, payload: any) {
    return this.apiService.post(apiUrl, payload);
  }
  dynamicGetLandingListCount(apiUrl: string) {
    return this.apiService.get(apiUrl)
  }
  dynamicPostLandingListCount(apiUrl: string, payload: any) {
    return this.apiService.post(apiUrl, payload)
  }
  sendNotifications(payload: any) {
    return this.apiService.post(`${environment.alert_api_url}/api/alert/save`, payload);
  }
  getAlerts(payload: any) {

    return this.apiService.post(`${environment.alert_api_url}/api/alert/notification-details`, payload);
  }

  updateAlertAction(payload: any) {
    return this.apiService.post(`${environment.alert_api_url}/api/update/inapp/notification/status`, payload)
  }
  updateAlertAssignment(payload: any) {
    return this.apiService.post(`${environment.alert_api_url}/api/alert/assign`, payload)
  }
  caseStatusEdit(param: string) {
    return this.apiService.get(`${environment.case_api_url}/api/generic/getGenericMasterList?catgId=${param}`)
  }
  saveChanges(payload: any, sectioncode: any) {
    return this.apiService.post(`${environment.common_url}/common/dynamic/createOrUpdate?sectionCode=${sectioncode}&locale=en`, payload)
  }
  getResultSet(id: any, obj: any): Observable<any> {
    let params = new URLSearchParams();

    for (let key in obj) {
      if (obj[key] == null) {
        params.set(key, '');
      } else {
        params.set(key, obj[key]);
      }
    }
    return this.apiService.post(
      `${environment.report_api_url}/report/param/submit?reportId=${id}&${params}`,
      obj
    );
  }
  genericList(params: any): Observable<any> {
    return this.apiService.get(
      `${environment.report_api_url}/common/getGenericMasterList?lgmCatgId=${params}`
    );
  }
  downloadExcelReport(id: any, obj: any, groupBy: any): Observable<any> {
    let params = new URLSearchParams();
    for (let key in obj) {
      params.set(key, obj[key]);
    }
    return this.apiService.get(
      `${environment.report_api_url}/report/list/excel?reportId=${id}&groupBy=${groupBy}&${params}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public downloadPDFReport(id: any, obj: any, groupBy: any): Observable<any> {
    let params = new URLSearchParams();

    for (let key in obj) {
      params.set(key, obj[key]);
    }
    return this.apiService.get(
      `${environment.report_api_url}/report/list/pdf?reportId=${id}&groupBy=${groupBy}&${params}`,
      { responseType: 'arraybuffer', observe: 'response' }
    );
  }
  public getReportDetails(id: any): Observable<any> {
    return this.apiService.get(
      `${environment.report_api_url}/report/param/list?reportId=${id}`
    );
  }
  getCaseAnalysisJson() {
    return this.apiService.get(`${environment.case_api_url}/api/case/link/analysis`)
  }
  getAlertById(alertId: string) {
    return this.apiService.get(`${environment.alert_api_url}/api/alert/details?alertId=${alertId}`)
  }
  getCaseLinkAnalysisDiagram(cifNumber: string) {
    return this.apiService.get(`${environment.case_api_url}/api/case/link/analysis/diagram?cifNumber=${cifNumber}`)
  }
  getCaseActivityHistory(caseId: string) {
    return this.apiService.get(`${environment.case_api_url}/api/case/history/details?caseId=${caseId}`)
  }
  saveCaseActivityHistory(payload: any) {
    return this.apiService.post(`${environment.case_api_url}/api/case/history/save`, payload)
  }
  getExportData(payload: any, moduleCode: string, reportType: string) {
    return this.apiService.post(`${environment.common_url}/common/reports/export?moduleCode=${moduleCode}&reportType=${reportType}&locale=en`, payload, { responseType: 'arraybuffer', observe: 'response' })
  }
  getCaseCheck(payload: any) {
    return this.apiService.post(`${environment.inquries_api_url}/api/inquiry/check-yn`, payload)
  }
  dynamicPostLandingListInquiry(apiUrl: any) {
    return this.apiService.get(apiUrl)
  }
  createInquires(payload: any) {
    return this.apiService.post(`${environment.inquries_api_url}/api/inquiry/save`, payload);
  }
  createTask(payload: any) {
    return this.apiService.post(`${environment.task_api_url}/api/task/save`, payload);
  }
  getInquiry(payload: any) {
    return this.apiService.post(`${environment.inquries_api_url}/api/inquiry/detail`, payload);
  }

  getTask(payload: any) {
    return this.apiService.post(`${environment.task_api_url}/api/task/detail`, payload);
  }
  getInquiryDetails(caseId: any) {
    return this.apiService.get(`${environment.inquries_api_url}/api/inquiry/by-case/${caseId}`);
  }

  getTaskDetails(caseId: any) {
    return this.apiService.get(`${environment.task_api_url}/api/task/by-case/${caseId}`);
  }
  generateId(moduleCode: string): Observable<any> {
    return this.apiService.get(`${environment.common_url}/common/generate-id?moduleCode=${moduleCode}`);
  }

}
